import { render, staticRenderFns } from "./today-sessions.vue?vue&type=template&id=36f1885c&"
import script from "./today-sessions.vue?vue&type=script&lang=js&"
export * from "./today-sessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports